import React, { createContext, useState } from 'react';

export const AppContext = createContext();

export const AppProvider = ({ children }) => {
  const [hostname, setHostname] = useState(window.location.hostname);

  return (
    <AppContext.Provider value={{ hostname, setHostname }}>
      {children}
    </AppContext.Provider>
  );
};